import { SetGenderMode as DLSetGenderMode, GetUserZone as DLGetUserZone, SaveUserZone as DLSaveUserZone, SubmitResponse as DLSubmitResponse, SendQuestionToUsers as DLSendQuestionToUsers, GetAllResults as DLGetAllResults, GetResultsByQuestion as DLGetResultsByQuestion, ResetAllResults as DLResetAllResults, SendResultsToScreen as DLSendResultsToScreen, GetColors as DLGetColors, SetColor as DLSetColor, ResetCurrentDynamic as DLResetCurrentDynamic, StartLottery as DLStartLottery, SendNextCard as DLSendNextCard, GetAllLotteryResults as DLGetAllLotteryResults, GetAllLotteryResultsByCard as DLGetAllLotteryResultsByCard, ValidateResponse as DLValidateResponse, GetGenderMode as DLGetGenderMode, StartBallonsGame as DLStartBallonsGame, RestartBallonsGame as DLRestartBallonsGame, GetBalloonState as DLGetBalloonState, GetBalloonStats as DLGetBalloonStats, SendBalloonsTap as DLSendBalloonsTap, GetAllRiddleResults as DLGetAllRiddleResults, SendRiddleResultsToScreen as DLSendRiddleResultsToScreen, SendRiddleQuestionToUsers as DLSendRiddleQuestionToUsers, ShowItemOnScreen as DLShowItemOnScreen, CloseRiddleVoting as DLCloseRiddleVoting, SaveRiddleGameSession as DLSaveRiddleGameSession, SubmitRiddleResponse as DLSubmitRiddleResponse, GetAutozoneState as DLGetAutozoneState, SetAutozoneState as DLSetAutozoneState, GetAllQuizzWithImageAndOptionsResults as DLGetAllQuizzWithImageAndOptionsResults, SendQuizzWithImageAndOptionsResultsToScreen as DLSendQuizzWithImageAndOptionsResultsToScreen, SendQuizzWithImageAndOptionsQuestionToUsers as DLSendQuizzWithImageAndOptionsQuestionToUsers, SubmitQuizzWithImageAndOptionsResponse as DLSubmitQuizzWithImageAndOptionsResponse } from './../DL/Zones'; //ValidateUserZone as DLValidateUserZone
import SignalRService from '../WS/SignalRService';


const phase = {
  WAITING: "WAITING",
  RUNNING: "RUNNING",
  FINISHED: "FINISHED",
}


const GetGenderMode = async () => {
    try {
        const response = await DLGetGenderMode()
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar cargar la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

const SetGenderMode = async (activeWomensMode) => {
  try {
    const response = await DLSetGenderMode(activeWomensMode)
        
    if (response.success) {
        return { success: true, data: response.data }
    } else {
        return { success: false, message: response.message }
    }
  } catch (error) {
    return { success: false, message: 'Lo sentimos. Hubo un error al intentar cambiar el modo de la aplicación. Intenta actualizar la página o inténtalo más tarde.' }
  }
}

/**
 * Función que obtiene la información de la zona (del estadio) que tiene el usuario
 * @returns 
 */
const GetUserZone = async () => {
    try {
        if (!navigator.onLine) {
            const cachedZone = localStorage.getItem('user_zone');
            if (cachedZone) {
                return {
                    success: true,
                    data: {
                        id: 1,
                        name: cachedZone.toUpperCase(),
                        text: cachedZone
                    }
                };
            }
        }

        const response = await DLGetUserZone()

        if (response.success) {
            if (response.data && response.data.text) {
                localStorage.setItem('user_zone', response.data.text);
            }
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        const cachedZone = localStorage.getItem('user_zone');
        if (cachedZone) {
            return {
                success: true,
                data: {
                    id: 1,
                    name: cachedZone.toUpperCase(),
                    text: cachedZone
                }
            };
        }
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

/**
 * Función que valida si el texto que recibe es una zona válida (Ej. "zona1", "zona2")
 * Ahora lo valida dinámicamente contra el servidor.
 * @param {string} _zone 
 * @returns 
 */
const ValidateZone = async (_zone) => {
  try {
    const zone = _zone.trim().toLowerCase();

    // Validar formato general (letras, números y espacios)
    const regex = /^[\p{L}\p{N} ]+$/u;
    if (!regex.test(zone)) {
        return { success: false, message: 'Lo sentimos. La zona que elegiste no es válida' }
    }
    
    // Obtenemos las zonas activas dinámicamente desde el backend
    const activeZonesResponse = await GetActiveStadiumZones();
    if (!activeZonesResponse.success || !activeZonesResponse.data) {
        return { success: false, message: 'No se pudieron obtener las zonas activas del servidor.' };
    }

    // Buscamos si la zona que nos pasaron existe en la lista del servidor
    // Comparamos contra el 'internalName' (ej. "zona1")
    const matchedZone = activeZonesResponse.data.find(z => z.internalName.toLowerCase() === zone);

    if (matchedZone) {
      let zoneData = {
        id: matchedZone.id,
        name: matchedZone.displayName, // Ej. "Xolo Mayor Rojo"
        text: matchedZone.internalName // Ej. "zona1"
      };
      return { success: true, data: zoneData };
    } else {
      return { success: false, message: 'Lo sentimos. La zona que elegiste no es válida para este evento.' };
    }
  } catch (error) {
    return { success: false, message: 'No ha sido posible validar la zona' };
  }
}

/**
 * Función que valida si el id que recibe es una zona válida
 * Ahora lo valida dinámicamente contra el servidor.
 * @param {string|number} numberZone
 * @returns 
 */
const ValidateNumberZone = async (numberZone) => {
  try {
    const idToSearch = parseInt(numberZone, 10);
    
    if (isNaN(idToSearch) || idToSearch <= 0) {
        return { success: false, message: 'ID de zona inválido' }
    }
    
    // Obtenemos las zonas activas dinámicamente
    const activeZonesResponse = await GetActiveStadiumZones();
    if (!activeZonesResponse.success || !activeZonesResponse.data) {
        return { success: false, message: 'No se pudieron obtener las zonas activas del servidor.' };
    }

    // Buscamos por ID
    const matchedZone = activeZonesResponse.data.find(z => z.id === idToSearch);

    if (matchedZone) {
      const zoneData = {
        text: matchedZone.internalName // Retornamos el internalName (Ej. "zona1") que es lo que espera el sistema para guardar la sesión
      };
      return { success: true, data: zoneData };
    } else {
      return { success: false, message: 'Lo sentimos. La zona que elegiste no es válida.' };
    }
  } catch (error) {
    return { success: false, message: 'No ha sido posible validar la zona' };
  }
}

/**
 * Función que guarda la zona (del estadio) que eligió el usuario o que le fue asignada
 * @param {object} zone
 * @returns 
 */
const SaveUserZone = async (zone) => {
  try {
    if (!navigator.onLine) {
      const zoneName = zone.trim();
      const zoneData = {
        id: 1,
        name: zoneName.toUpperCase(),
        text: zoneName
      }
      localStorage.setItem('user_zone', zoneName);
      return { success: true, data: zoneData };
    }

    // Valida que sea una zona válida y obtiene la información de esta
    const responseValidate = await ValidateZone(zone)
    
    if (responseValidate.success) {
      // Crear objeto con info de la zona
      const zoneData = {
        id: responseValidate.data.id,
        name: responseValidate.data.name,
        text: responseValidate.data.text
      }
      
      localStorage.setItem('user_zone', zoneData.text);
      const response = await DLSaveUserZone(zoneData)
      
      if (response.success) {
        return { success: true, data: response.data }
      } else {
        return { success: false, message: response.message }
      }
    } else {
      return { success: false, message: responseValidate.message }    
    }
  } catch (error) {
      // Fallback local en caso de excepción de red
      try {
        const zoneName = zone.trim();
        localStorage.setItem('user_zone', zoneName);
        return { 
          success: true, 
          data: { 
            id: 1, 
            name: zoneName.toUpperCase(), 
            text: zoneName 
          } 
        };
      } catch (e) {}
      return { success: false, message: 'Lo sentimos. Hubo un error al intentar guardar tu zona. Inténtalo nuevamente o inténtalo más tarde.' }
  }
}










// ---------- Websockets ----------//

let pendingMessages = []
let currentMessageHandler = null
let zonesMessageHandler = null
let zonesReconnectedHandler = null

const IsWebSocketReady = () => {
  return SignalRService.isConnected
}

const _resetWsState = () => {
  if (zonesMessageHandler) {
    SignalRService.off('message', zonesMessageHandler);
    zonesMessageHandler = null;
  }
  if (zonesReconnectedHandler) {
    SignalRService.off('reconnected', zonesReconnectedHandler);
    zonesReconnectedHandler = null;
  }
  SignalRService.disconnect();
}

const DisconnectWebSocket = () => {
  try { _resetWsState() } catch {}
}

const WaitUntilConnected = (timeout = 5000) => {
  return new Promise((resolve, reject) => {
    const start = Date.now()
    const check = () => {
      if (IsWebSocketReady()) resolve(true)
      else if (Date.now() - start > timeout) reject(new Error('El WebSocket no se conectó a tiempo'))
      else setTimeout(check, 100)
    }
    check()
  })
}

const _setupSignalRHandlers = (onStatusChange) => {
  if (zonesMessageHandler) {
    SignalRService.off('message', zonesMessageHandler);
  }
  if (zonesReconnectedHandler) {
    SignalRService.off('reconnected', zonesReconnectedHandler);
  }

  zonesMessageHandler = (payload) => {
    try {
      if (payload.type === 'assignedZone') {
        const rawData = sessionStorage.getItem(process.env.REACT_APP_SESSION)
        const session = rawData ? JSON.parse(rawData) : {}
        session.navigation = session.navigation || {}
        session.navigation.zone = { id: null, text: payload.data.zone }
        sessionStorage.setItem(process.env.REACT_APP_SESSION, JSON.stringify(session))
      }

      pendingMessages.push(payload)

      if (typeof currentMessageHandler === 'function') {
        const queue = pendingMessages
        pendingMessages = []
        for (const msg of queue) {
          try { currentMessageHandler(msg) } catch (e) { console.error('[SignalR] handler error:', e) }
        }
      }
    } catch (err) {
      console.error('[SignalR] ❌ Error al procesar mensaje:', err)
    }
  }

  zonesReconnectedHandler = async () => {
    onStatusChange('connected');
    console.log('[SignalR] Conexión restablecida con éxito. Iniciando re-inscripción agresiva de zona...');

    const maxRetries = 5;
    const retryDelay = 2000;

    const attemptJoinZone = async (retryCount = 0) => {
      try {
        const response = await GetUserZone();
        const zoneToJoin = (response?.success && response?.data?.text) || localStorage.getItem('user_zone');

        if (zoneToJoin) {
          console.log(`[SignalR] Intentando JoinZone para la zona: ${zoneToJoin} (Intento ${retryCount + 1}/${maxRetries})`);
          await SignalRService.invoke('JoinZone', zoneToJoin);
          console.log(`[SignalR] Auto-JoinZone exitoso tras reconexión para la zona: ${zoneToJoin}`);
          return true;
        } else {
          console.log(`[SignalR] Sin zona local previa tras reconexión. Invocando JoinZone("") para asignación automática.`);
          await SignalRService.invoke('JoinZone', '');
          return true;
        }
      } catch (err) {
        console.error(`[SignalR] Error en attemptJoinZone (Intento ${retryCount + 1}/${maxRetries}):`, err);
        if (retryCount < maxRetries - 1) {
          console.log(`[SignalR] Reintentando JoinZone en ${retryDelay}ms...`);
          await new Promise(resolve => setTimeout(resolve, retryDelay));
          return await attemptJoinZone(retryCount + 1);
        }
        return false;
      }
    };

    await attemptJoinZone();
  }

  SignalRService.on('message', zonesMessageHandler);
  SignalRService.on('reconnected', zonesReconnectedHandler);
}

const ConnectWebSocket = async (zoneName, onStatusChange = () => {}, onToast = () => {}, roomId = null) => {
  _setupSignalRHandlers(onStatusChange)

  const resolvedRoomId = roomId || new URLSearchParams(window.location.search).get('roomId');

  if (SignalRService.isConnected) {
    console.log(`[Zones.js] La conexión ya está activa (SaaS V2). Uniéndose a la zona: ${zoneName || 'automática'} de forma inamovible.`);
    onStatusChange('connected');
    onToast('Conectado');
    try {
      await SignalRService.invoke('JoinZone', zoneName || '');
      console.log(`[Zones.js] JoinZone invocado con éxito para: ${zoneName || 'modo automático'}`);
    } catch (err) {
      console.error('[Zones.js] Error al invocar JoinZone:', err);
    }
    return;
  }

  // Fallback V1/Estadio: Abrir nueva conexión con tipo 'aficionado' para garantizar registro de estadísticas
  onStatusChange('connecting')
  SignalRService.connect({ zona: zoneName, tipo: 'aficionado', roomId: resolvedRoomId })
    .then(() => {
      onStatusChange('connected')
      onToast('Conectado')
    })
    .catch((err) => {
      console.error('[SignalR] Error al conectar zona:', err)
      onStatusChange('error')
    })
}

const UpdateZone = async (zoneName, roomId = null) => {
  const resolvedRoomId = roomId || new URLSearchParams(window.location.search).get('roomId');
  if (SignalRService.isConnected) {
    console.log(`[Zones.js] UpdateZone: actualizando zona en el Hub a: ${zoneName}`);
    try {
      await SignalRService.invoke('JoinZone', zoneName);
    } catch (err) {
      console.error('[Zones.js] Error al invocar JoinZone en UpdateZone:', err);
    }
  } else {
    console.warn('[Zones.js] UpdateZone: SignalR no está conectado. Iniciando conexión...');
    await ConnectWebSocket(zoneName, () => {}, () => {}, resolvedRoomId);
  }
}

const SetSocketMessageHandler = (onMessage) => {
  currentMessageHandler = typeof onMessage === 'function' ? onMessage : null

  if (typeof currentMessageHandler === 'function' && pendingMessages.length > 0) {
    const queue = pendingMessages
    pendingMessages = []
    for (const msg of queue) {
      try { currentMessageHandler(msg) } catch (e) { console.error('[SignalR] handler error:', e) }
    }
  }
}

const ClearSocketMessageHandler = () => {
  currentMessageHandler = null
}

const ConnectWebSocketForScreen = async (onStatusChange = () => {}, onToast = () => {}, roomId = null) => {
  onStatusChange('connecting')
  _setupSignalRHandlers(onStatusChange)

  const resolvedRoomId = roomId || new URLSearchParams(window.location.search).get('roomId');

  SignalRService.connect({ tipo: 'pantalla', roomId: resolvedRoomId })
    .then(() => {
      onStatusChange('connected')
      onToast('¡Pantalla conectada!')
    })
    .catch((err) => {
      if (err?.name === 'AbortError' || err?.message?.includes('negotiation')) {
        console.warn('[SignalR] Conexión anterior de pantalla cancelada durante negociación.');
        return;
      }
      console.error('[SignalR] Error al conectar pantalla:', err);
      onStatusChange('error');
    })
}

const ConnectWebSocketForScreenV2 = async (screenId, onStatusChange = () => {}, onToast = () => {}) => {
  onStatusChange('connecting')
  _setupSignalRHandlers(onStatusChange)

  const uid = `screen-v2-${screenId}`
  SignalRService.connect({ tipo: `pantalla-v2:${screenId}`, uid: uid })
    .then(() => {
      onStatusChange('connected')
      onToast(`¡Lienzo V2 (${screenId}) Conectado!`)
    })
    .catch((err) => {
      if (err?.name === 'AbortError' || err?.message?.includes('negotiation')) {
        console.warn('[SignalR] Conexión anterior de ScreenV2 cancelada durante negociación.');
        return;
      }
      console.error('[SignalR] Error al conectar ScreenV2:', err);
      onStatusChange('error');
    })
}

// ---------- Websockets ----------//



//---------- SCREEN ----------//

const SubmitResponse = async (questionId) => {
  try {
    const responseZone = await GetUserZone()
    
    if (responseZone.success) {
      const zone = responseZone?.data?.text
      
      if (zone) {
        const response = await DLSubmitResponse(questionId, zone)
        
        if (response.success) {
          return { success: true, data: response.data }
        } else {
          return { success: false, message: response.message }
        }
      }
    } else {

    }
  } catch (error) {
    
  }
}

//---------- SCREEN ----------//

//---------- QUIZ ADMIN ----------//

const SendQuestionToUsers = async (question) => {
  try {
    const response = await DLSendQuestionToUsers(question)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const GetAllResults = async () => {
  try {
    const response = await DLGetAllResults()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const GetResultsByQuestion = async (question) => {
  try {
    const idQuestion = question?.id
    if (!idQuestion) {
      return { success: false, message: 'No ha sido posible obtener los resultados. Inténtalo nuevamente o inténtalo más tarde.' }
    }

    const response = await DLGetResultsByQuestion(idQuestion)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const ResetAllResults = async () => {
  try {
    const response = await DLResetAllResults()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const SendResultsToScreen = async () => {
  try {
    const response = await DLSendResultsToScreen()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

//---------- QUIZ ADMIN ----------//

//---------- COLORS ADMIN ----------//

const GetColors = async () => {
  try {
    const response = await DLGetColors()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const SetColor = async (idTheme) => {
  try {
    const response = await DLSetColor(idTheme)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const ResetCurrentDynamic = async () => {
  try {
    const response = await DLResetCurrentDynamic()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

//---------- COLORS ADMIN ----------//

//---------- LOTTERY ADMIN ----------//

const StartLottery = async (boardSize, view) => {
  try {
    const response = await DLStartLottery(boardSize, view)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const SendNextCard = async (card, view) => {
  try {
    const response = await DLSendNextCard(card, view)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const GetAllLotteryResults = async () => {
  try {
    const response = await DLGetAllLotteryResults()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const GetAllLotteryResultsByCard = async () => {
  try {
    const response = await DLGetAllLotteryResultsByCard()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

//---------- LOTTERY ADMIN ----------//

//---------- BALLONS ADMIN ----------//

// Mapea el status del backend a las fases del admin
const MapStatusToPhase = (status) => {
  switch (status) {
    case 0: // BalloonMatchStatus.Waiting
    case "Waiting":
      return phase.WAITING
    case 1: // Running
    case "Running":
      return phase.RUNNING
    case 2: // Finished
    case "Finished":
      return phase.FINISHED
    default:
      return phase.WAITING
  }
}

const StartBallonsGame = async (points, time, countdown = 3, sendBatchThreshold = 10, sendBatchTimeoutMs = 0) => {
  try {
    // const target = Number(points) || 120
    // const duration = Number(time) || 30
    // const cd = Number(countdown) || 3

    // if (target < 1) return { success: false, message: "La meta de puntos debe ser >= 1" }
    // if (duration < 5) return { success: false, message: "La duración debe ser >= 5s" }
    // if (cd < 1) return { success: false, message: "El countdown debe ser >= 1s" }

    const target   = Number(points)            || 120
    const duration = Number(time)              || 30
    const cd       = Number(countdown)         || 3
    const th       = Number(sendBatchThreshold) || 10
    const toMs     = Number(sendBatchTimeoutMs) || 0

    if (target   < 1) return { success: false, message: "La meta de puntos debe ser >= 1" }
    if (duration < 5) return { success: false, message: "La duración debe ser >= 5s" }
    if (cd       < 1) return { success: false, message: "El countdown debe ser >= 1s" }
    if (th       < 1) return { success: false, message: "El umbral de envío debe ser >= 1" }
    if (toMs     < 0) return { success: false, message: "El timeout de envío no puede ser negativo" }
    
    const response = await DLStartBallonsGame(target, duration, cd, th, toMs)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    console.log('BL StartBallonsGame: ' + error)
    return { success: false, message: `Ha habido un error al iniciar la dinámica de Globos: ${error}` }
  }
}

const RestartBallonsGame = async () => {
  try {
    const response = await DLRestartBallonsGame()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    console.log('BL RestartBallonsGame: ' + error)
    return { success: false, message: `Ha habido un error al intentar resetear la dinámica: ${error}` }
  }
}

const GetBalloonState = async () => {
  try {
    const response = await DLGetBalloonState()
    
    if (response.success) {
      //return { success: true, data: response.data }
      return {
        success: true,
        data: {
          phase: MapStatusToPhase(response.data.status),
          state: response.data
        }
      }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    console.log('BL GetBalloonState: ' + error)
    return { success: false, message: `Ha habido un error al consultar el estado: ${error}` }
  }
}

const GetBalloonStats = async () => {
  try {
    const response = await DLGetBalloonStats()
    
    /* s: {
         matchId, status, startAt, endsAt, targetTapsPerBalloon,
         peakParticipantsTotal,
         currentParticipantsByZone: { [zona]: count },
         resultsByZone: [{ zone, completedBalloons, totalTaps }],
         winnerType, winners
       }
    */

    if (response.success) {
      //return { success: true, data: response.data }
      return {
        success: true,
        data: {
          phase: MapStatusToPhase(response.data.status),
          stats: response.data
        }
      }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    console.log('BL GetBalloonStats: ' + error)
    return { success: false, message: `Ha habido un error al consultar las estadísticas: ${error}` }
  }
}

//---------- BALLONS ADMIN ----------//

//---------- RIDDLE ADMIN ----------//

const GetAllRiddleResults = async (roomId = null) => {
  try {
    const response = await DLGetAllRiddleResults(roomId)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    return { success: false, message: 'Error al obtener resultados de adivinanzas' }
  }
}

const SendRiddleResultsToScreen = async (roomId = null) => {
  try {
    const response = await DLSendRiddleResultsToScreen(roomId)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    return { success: false, message: 'Error al enviar resultados a pantalla' }
  }
}

const SendRiddleQuestionToUsers = async (question, roomId = null) => {
  try {
    const response = await DLSendRiddleQuestionToUsers(question, roomId)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    return { success: false, message: 'Error al enviar pregunta de adivinanza' }
  }
}

const ShowItemOnScreen = async (question, roomId = null) => {
  try {
    const response = await DLShowItemOnScreen(question, roomId)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    return { success: false, message: 'Error al mostrar elemento en pantalla' }
  }
}

const CloseRiddleVoting = async (questionId, roomId = null) => {
  try {
    const response = await DLCloseRiddleVoting(questionId, roomId)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    return { success: false, message: 'Error al cerrar votación de adivinanza' }
  }
}

const SaveRiddleGameSession = async (sessionData) => {
  try {
    const response = await DLSaveRiddleGameSession(sessionData)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    return { success: false, message: 'Error al guardar la sesión de adivinanza' }
  }
}

//---------- RIDDLE ADMIN ----------//



//---------- LOTTERY FAN ----------//

const ValidateResponse = async (idCard) => {
  try {
    const responseZone = await GetUserZone()
    
    if (responseZone.success) {
      const response = await DLValidateResponse(idCard, responseZone.data.text)
      
      if (response.success) {
        return { success: true, data: response.data }
      } else {
        return { success: false, message: response.message }
      }
    } else {
      return { success: false, message: responseZone.message }
    }
  } catch (error) {
    
  }    
}

//---------- LOTTERY FAN ----------//

//---------- BALLONS FAN ----------//

const SendBalloonsTap = async (matchId, zone, toSend) => {
  try {
    const response = await DLSendBalloonsTap(matchId, zone, toSend)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    console.log(error)
  }
}

//---------- BALLONS FAN ----------//

//---------- RIDDLE FAN ----------//

const SubmitRiddleResponse = async (questionId, selectedOption, zone = null, roomId = null) => {
  try {
    let resolvedZone = zone;
    if (!resolvedZone) {
      const responseZone = await GetUserZone()
      if (responseZone.success && responseZone?.data?.text) {
        resolvedZone = responseZone.data.text
      }
    }
    
    if (resolvedZone) {
      const resolvedRoomId = roomId || new URLSearchParams(window.location.search).get('roomId');
      const response = await DLSubmitRiddleResponse(questionId, selectedOption, resolvedZone, resolvedRoomId)
      
      if (response.success) {
        return { success: true, data: response.data }
      } else {
        return { success: false, message: response.message }
      }
    } else {
      return { success: false, message: 'Zona no identificada' }
    }
  } catch (error) {
    return { success: false, message: 'Error al enviar respuesta de adivinanza' }
  }
}

//---------- RIDDLE FAN ----------//


//---------- QuizzWithImageAndOptions ADMIN ----------//

const GetAllQuizzWithImageAndOptionsResults = async () => {
  try {
    const response = await DLGetAllQuizzWithImageAndOptionsResults()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const SendQuizzWithImageAndOptionsResultsToScreen = async () => {
  try {
    const response = await DLSendQuizzWithImageAndOptionsResultsToScreen()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const SendQuizzWithImageAndOptionsQuestionToUsers = async (question) => {
  try {
    const response = await DLSendQuizzWithImageAndOptionsQuestionToUsers(question)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

//---------- QuizzWithImageAndOptions ADMIN ----------//


//---------- QuizzWithImageAndOptions FAN ----------//

const SubmitQuizzWithImageAndOptionsResponse = async (questionId) => {
  try {
    const responseZone = await GetUserZone()
    
    if (responseZone.success) {
      const zone = responseZone?.data?.text
      
      if (zone) {
        const response = await DLSubmitQuizzWithImageAndOptionsResponse(questionId, zone)
        
        if (response.success) {
          return { success: true, data: response.data }
        } else {
          return { success: false, message: response.message }
        }
      }
    } else {

    }
  } catch (error) {
    
  }
}

//---------- QuizzWithImageAndOptions FAN ----------//



const GetAutozoneState  = async () => {
  try {
    const response = await DLGetAutozoneState()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const SetAutozoneState  = async (enabled) => {
  try {
    const response = await DLSetAutozoneState(enabled)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}



// ---------- Overlays Websockets ----------//

/**
 * Conecta un Overlay específico al WebSocket.
 * @param {string} overlayType - El subtipo de overlay (ej: "karaoke", "stats").
 * @param {function} onStatusChange - Callback para actualizar estado de conexión (connecting, connected, etc).
 * @param {function} onToast - Callback para mostrar mensajes toast/notificaciones.
 */
const ConnectWebSocketForOverlay = async (overlayType, onStatusChange = () => {}, onToast = () => {}, roomId = null) => {
  onStatusChange('connecting')
  _setupSignalRHandlers(onStatusChange)

  const resolvedRoomId = roomId || new URLSearchParams(window.location.search).get('roomId');

  SignalRService.connect({ tipo: `overlay:${overlayType}`, roomId: resolvedRoomId })
    .then(() => {
      onStatusChange('connected')
      onToast(`Overlay ${overlayType} Conectado`)
    })
    .catch((err) => {
      console.error('[SignalR] Error al conectar Overlay:', err)
      onStatusChange('error')
    })
}

// ---------- Overlays Websockets ----------//

// Mover a DL
const GetActiveStadiumZones = async (roomId = null) => {
    try {
        const resolvedRoomId = roomId || new URLSearchParams(window.location.search).get('roomId');
        const headers = {};
        if (resolvedRoomId) {
            headers['X-Room-Id'] = resolvedRoomId;
            headers['roomId'] = resolvedRoomId;
        }
        const response = await fetch(`${process.env.REACT_APP_API_URL}Stadium/ActiveZones`, {
            method: 'GET',
            headers: headers
        });
        if (response.ok) {
            const data = await response.json();
            return { success: true, data };
        }
        return { success: false, data: [] };
    } catch {
        return { success: false, data: [] };
    }
};

export { GetGenderMode, SetGenderMode, IsWebSocketReady, WaitUntilConnected, GetUserZone, ValidateZone, ValidateNumberZone, SaveUserZone, ConnectWebSocket, DisconnectWebSocket, SetSocketMessageHandler, ClearSocketMessageHandler, ConnectWebSocketForScreen, ConnectWebSocketForScreenV2, SubmitResponse, SendQuestionToUsers, GetAllResults, GetResultsByQuestion, ResetAllResults, SendResultsToScreen, GetColors, SetColor, ResetCurrentDynamic, StartLottery, SendNextCard, GetAllLotteryResults, GetAllLotteryResultsByCard, StartBallonsGame, RestartBallonsGame, GetBalloonState, GetBalloonStats, GetAllRiddleResults, SendRiddleResultsToScreen, SendRiddleQuestionToUsers, ShowItemOnScreen, CloseRiddleVoting, SaveRiddleGameSession, ValidateResponse, SendBalloonsTap, SubmitRiddleResponse, GetAutozoneState, SetAutozoneState, GetAllQuizzWithImageAndOptionsResults, SendQuizzWithImageAndOptionsResultsToScreen, SendQuizzWithImageAndOptionsQuestionToUsers, SubmitQuizzWithImageAndOptionsResponse, ConnectWebSocketForOverlay, GetActiveStadiumZones, UpdateZone }; //ValidateUserZone